<template>
  <KioskCenteredLayout>
    <div :class="$style.checkmark">
      <svg v-svg
           :class="$style.checkmarkIcon"
           symbol="checkmark-icon" />
    </div>
    <KioskMessageTitle
      title="Discount Code Applied!"
    />
  </KioskCenteredLayout>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import KioskCenteredLayout from '@/layouts/KioskCenteredLayout';
import KioskMessageTitle from '@/components/KioskMessageTitle';
import { CART_DISPLAY } from '@/apps/cart/store/types';
import { Mutation } from 'vuex-class';

/**
 * Provide discount code applying message
 */
@Component({
  components: {
    KioskCenteredLayout,
    KioskMessageTitle,
  },
})
export default class KioskDiscountApply extends Vue {
  @Mutation(CART_DISPLAY) cartDisplay;

  created() {
    setTimeout(() => {
      this.$router.push({ name: 'menu' });
      this.cartDisplay(true);
    }, 2000);
  }
}
</script>

<style lang="scss" module>
@import '@/style/variables.scss';

.checkmark {
  width: 260px;
  height: 260px;
  background-color: $white;
  border-radius: 50%;
  margin: 0 auto 88px;
  .checkmarkIcon {
    fill: $green-color;
    width: 260px;
    height: 260px;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/KioskDiscountApply.vue